import { Box } from '@mui/material';
import { BenefitDTOBenefitEnum, CouponDefinitionListDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { AvailableCouponsAccordion } from '../coupons/AvailableCouponsDrawer';
import { floorToOrderableCouponAmount, NonCashBenefit } from './const';

interface Props {
  nonCashBenefits?: NonCashBenefit[];
  couponBudget: number;
}
export const NonCashAvailableCouponsAccordion: React.FC<Props> = ({ couponBudget: couponAmount, nonCashBenefits }) => {
  const { tenant } = useTenant();
  const { data } = useTenantQuery(
    ['benefits', 'coupons', 'definition', apis.coupons.findCouponDefinitions.name],
    tenantId => apis.coupons.findCouponDefinitions({ tenantId, sortBy: ['name:asc'] }).then(resp => resp.data),
    {
      enabled: tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Coupons) && nonCashBenefits?.includes(BenefitDTOBenefitEnum.Coupons),
    },
  );

  return (
    tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Coupons) && (
      <Accordion
        coupons={nonCashBenefits?.includes(BenefitDTOBenefitEnum.Coupons) ? data : undefined}
        amount={floorToOrderableCouponAmount(couponAmount)}
      />
    )
  );
};

interface AccordionProps {
  coupons?: CouponDefinitionListDTO;
  amount: number;
}
const Accordion: React.FC<AccordionProps> = ({ amount, coupons }) => {
  return (
    <Box mt={2}>
      <AvailableCouponsAccordion coupons={coupons?.coupons} amount={amount} />
    </Box>
  );
};
